import React, { useRef, useState } from 'react';

export default function UnsupportedBrowser({ message }) {
    const linkRef = useRef(null);
    const [copyStatus, setCopyStatus] = useState('');

    const copyLink = async () => {
        const link = window.location.href;
        setCopyStatus('');
        try {
            if (!navigator.clipboard || !navigator.clipboard.writeText) throw new Error('Clipboard unavailable');
            await navigator.clipboard.writeText(link);
            setCopyStatus('copied');
        } catch (error) {
            // Embedded browsers may deny clipboard access. Keep manual copying available.
            const input = linkRef.current;
            input.focus();
            input.select();
            input.setSelectionRange(0, input.value.length);
            try {
                if (document.execCommand && document.execCommand('copy')) {
                    setCopyStatus('copied');
                    return;
                }
            } catch (copyError) {
                // The link remains selected for the browser's manual Copy action.
            }
            setCopyStatus('manual');
        }
    };

    return (
    <div className="candidate-page-shell" style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '24px', background: 'var(--candidate-bg, #f5f7fb)' }}>
        <div style={{ width: '100%', maxWidth: 520, background: 'var(--candidate-surface, #ffffff)', border: '1px solid var(--candidate-border, #d9e2ec)', borderRadius: 14, padding: 'clamp(24px, 5vw, 36px)', boxShadow: '0 18px 50px rgba(15, 23, 42, 0.12)', textAlign: 'left' }}>
            <div style={{ width: 52, height: 52, borderRadius: 14, background: '#f59e0b', color: '#ffffff', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 28, marginBottom: 18 }}>
                <i className="mdi mdi-google-chrome"></i>
            </div>
            <h2 style={{ color: 'var(--candidate-text, #111827)', fontSize: '1.55rem', fontWeight: 700, marginBottom: 10 }}>Verifique seu navegador</h2>
            <p style={{ color: 'var(--candidate-muted, #4b5563)', fontSize: '1rem', lineHeight: 1.6, marginBottom: 22 }}>
                {message}
            </p>
            <label htmlFor="external-camera-access-link" style={{ color: '#334155', fontSize: 14, fontWeight: 700 }}>Link de acesso</label>
            <input
                ref={linkRef}
                id="external-camera-access-link"
                type="text"
                value={window.location.href}
                readOnly
                onFocus={event => event.target.select()}
                style={{ display: 'block', width: '100%', minWidth: 0, height: 44, padding: '10px 12px', marginBottom: 16, border: '1px solid #cbd5e1', borderRadius: 8, background: '#f8fafc', color: '#334155', fontSize: 14 }}
            />
            <button
                type="button"
                onClick={copyLink}
                className="btn btn-primary"
                style={{ width: '100%', minHeight: 48, borderRadius: 10, fontWeight: 700, display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: 8 }}>
                <i className="mdi mdi-content-copy"></i>
                {copyStatus === 'copied' ? 'Link copiado!' : 'Copiar link'}
            </button>
            <p style={{ color: 'var(--candidate-muted, #6b7280)', fontSize: '.9rem', lineHeight: 1.5, margin: '16px 0 0' }}>
                Cole o link no Google Chrome ou no Safari compatível para entrar. O token de acesso presente no endereço será mantido.
            </p>
            <p role="status" aria-live="polite" style={{ margin: '12px 0 0', fontSize: 14, color: copyStatus === 'manual' ? '#b45309' : '#15803d' }}>
                {copyStatus === 'copied' && 'Link copiado. Abra o navegador e cole na barra de endereço.'}
                {copyStatus === 'manual' && 'Não foi possível copiar automaticamente. Toque e segure o link selecionado e escolha Copiar.'}
            </p>
        </div>
    </div>
);
}
